<template>
  <div class="py-4 text-center">
    <i class="mdi icon" :class="`mdi-${mdi_icon}`"></i>
    <div class="px-2 message">
      {{ message }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    mdi_icon: {
      type: String,
      default: "briefcase-variant",
    },
    message: {
      type: String,
      default: "Information indisponible",
    },
  },
};
</script>
<style scoped lang="css">
.icon {
  font-size: 50px;
  color: #000000 !important;
}
.message {
  font-size: 15px !important;
  line-height: 120% !important;
  font-weight: 500 !important;
}
</style>